import { useState,useEffect } from "react";
import Tooltip from "@tippyjs/react";
import { useNavigate } from "react-router-dom";

import DetailsPartyService from "../../../../services/party/detailsparty";
import { getTrans as t } from "../../../../Localization/translations";

function PartyShortdetilview({ id, setTab = null }) {
  const [customer_name, setCustomer_name] = useState("");
  const [partyref, setPartyRef] = useState("");
  useEffect(() => {
    DetailsPartyService.getPartyDetails(id).then((response) => {
      setCustomer_name(response.data.customer_name);
      setPartyRef(response.data.party_ref);
    })
  });
  let navigate = useNavigate();

  const handlePartyView = () => {
    if (setTab === null) {

      navigate("/party/details", { state: id });
    }
    else {
      setTab(0)
    }
  };

  return (
    <div>
      <div className="header pb-0 mb-3">
        <h5> {t("Party Details")}</h5>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="row" style={{ paddingBottom: "8px" }}>
            <div className="col-md-6 d-flex" style={{ justifyContent: 'space-between' }}>
              <span className="sub-title tc">
                {t("Party Name")}{" "}
                <Tooltip content={t("PartyName_Tooltip")}>
                  <i className="fa fa-light fa-circle-info"></i>
                </Tooltip>
              </span>
              <div className="col-md-6 d-flex" style={{ justifyContent: 'space-between' }}>
                <span
                  className="party-detail-font hyperlink"
                  onClick={() => handlePartyView()}
                >
                  {customer_name}
                </span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 d-flex" style={{ justifyContent: 'space-between' }}>
              <span className="sub-title tc">
                {t("Party Ref")}{" "}
                <Tooltip content={t("PartyName_Tooltip")}>
                  <i className="fa fa-light fa-circle-info"></i>
                </Tooltip>
              </span>
              <div className="col-md-6 d-flex" style={{ justifyContent: 'space-between' }}>
                <span className="party-detail-font ">
                  {partyref !== "null" ? partyref : "None"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartyShortdetilview;
